import styled from '@emotion/styled'

import { useTheme } from '@emotion/react'

import * as HeroRecipe from '@segment/matcha/recipes/Hero'

import useMatchMedia from '@segment/utils/useMatchMedia'

import heroPng2x from './assets/Hero@2x.png'
import heroWebp from './assets/Hero.webp'
import heroWebp2x from './assets/Hero@2x.webp'

import heroMobilePng2x from './assets/HeroMobile@2x.png'
import heroMobileWebp from './assets/HeroMobile.webp'
import heroMobileWebp2x from './assets/HeroMobile@2x.webp'

const HeroImage = () => {
  const theme = useTheme()
  const desktopResolutionMediaQuery = theme.breakpoints.up(`lg`, false)
  const isDesktop = useMatchMedia(desktopResolutionMediaQuery, true)
  let { webp, webp2, png2, size } = {
    webp: heroMobileWebp,
    webp2: heroMobileWebp2x,
    png2: heroMobilePng2x,
    size: [330, 487],
  }

  if (isDesktop) {
    webp = heroWebp
    webp2 = heroWebp2x
    png2 = heroPng2x
    size = [1128, 484]
  }

  return (
    <Picture>
      <source type="image/webp" srcSet={`${webp}, ${webp2} 2x`} />
      <HeroRecipe.Image width={size[0]} height={size[1]} src={png2} alt="Hero" />
    </Picture>
  )
}

const Picture = styled.picture`
  filter: drop-shadow(${({ theme }) => theme.shadows[1]});
`
export default HeroImage
